import React, { useState, useEffect } from "react";
import { Modal, howDoesItWork, Toast } from "../../../../Components";

export default function ModalConfirmReportMessage(props) {
  useEffect(() => {}, []);
  const [optionSelected, setOptionSelected] = useState(null);
  const [toastList, setToastList] = useState([]);
  const chkSelection = () => {
    if ((optionSelected !== null) & (optionSelected !== "")) {
      props.reportMessage();
    } else {
      addToast({
        error: true,
        msg: "Please select reason for reporting this message",
        id: `${Date.now()}`,
      });
    }
  };
  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };
  return (
    <Modal addClass="modalCamp" close={props.close}>
      <div className="modal__camp">
        <div className="modal__assetDetail-delete perm long">
          <h4>Why do you wish to report this message?</h4>
          <p className="sm reportAlert flex items-center gap-2">
            {howDoesItWork} Your report will be kept anonymous
          </p>
          <div>
            <ul className="reportChat">
              <li>
                {" "}
                <input
                  name="report"
                  id="payment"
                  onChange={() => {
                    setOptionSelected("payment");
                    props.setReportReason(
                      "The user asked for payment or wanted to communicate outside of TAMA"
                    );
                  }}
                  type="radio"
                />
                The user asked for payment or wanted to communicate outside of
                TAMA
              </li>
              <li>
                {" "}
                <input
                  name="report"
                  id="behaves"
                  onChange={() => {
                    setOptionSelected("behaves");
                    props.setReportReason("The user behaves inappropriately");
                  }}
                  type="radio"
                />
                The user behaves inappropriately.
              </li>
              <li>
                {" "}
                <input
                  name="report"
                  id="sentspam"
                  onChange={() => {
                    setOptionSelected("sentspam");
                    props.setReportReason("The user sent spam.");
                  }}
                  type="radio"
                />
                The user sent spam.
              </li>
              <li>
                {" "}
                <input
                  name="report"
                  id="other"
                  onChange={() => {
                    setOptionSelected("other");
                    props.setReportReason("other");
                  }}
                  type="radio"
                />
                Other
              </li>
            </ul>
          </div>
          <div className="modal__assetDetail-delete-btns">
            <button className="button secondary" onClick={props.close}>
              Cancel
            </button>
            <button className="button primary" onClick={chkSelection}>
              Report
            </button>
          </div>
        </div>
        {toastList && <Toast list={toastList} setList={setToastList} />}
      </div>
    </Modal>
  );
}
